import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IResetUserMfaVerifiersParams {
  username: string;
}

export class ResetUserMfaVerifiers extends Request<IResetUserMfaVerifiersParams, IResult> {
  constructor(username: string) {
    super('resetMFAVerifiers', { username: username});
  }
}
